import React, { useEffect, useState } from "react";
import { IoCaretBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import colors from "../config/colors";
import { useDispatch } from "react-redux";
import apiClient, { setAuthToken } from "../api/apiClient";
import { login } from "../redux/counterSlice";
import { toast } from "react-toastify";

export default () => {
  let loginState = {
    email: "",
    password: "",
  };

  useEffect(() => {
    document.title = "RollingAdz: Sign in" || "Default Title";

    const savedEmail = localStorage.getItem("email");
    const savedPassword = localStorage.getItem("password");
    const savedRememberMe = localStorage.getItem("rememberMe") === "true";

    if (savedEmail && savedPassword) {
      setLoginData({
        email: savedEmail,
        password: savedPassword,
      });
      setRememberMe(savedRememberMe);
    }
  }, []);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [loginData, setLoginData] = useState(loginState);
  const [rememberMe, setRememberMe] = useState(false);

  const handleChange = (key, value) => {
    setLoginData({ ...loginData, [key]: value });
  };

  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await apiClient.post("/authentication/login/", loginData);

      if (result.data && result.data.token) {
        const token = result.data.token.access;
        const accountType = result.data.user.account.account_type;
        const userName = `${result.data.user.first_name}`;

        if (token) {
          if (rememberMe) {
            localStorage.setItem("authToken", token);
            localStorage.setItem("email", loginData.email);
            localStorage.setItem("password", loginData.password);
            localStorage.setItem("rememberMe", true);
          } else {
            sessionStorage.setItem("authToken", token);
            localStorage.removeItem("email");
            localStorage.removeItem("password");
            localStorage.removeItem("rememberMe");
          }
          setAuthToken(token);
          dispatch(
            login({
              token: token,
              userId: result.data.user.account.user_id,
              userType: accountType,
              userName: userName,
            })
          );
          handleNavigate(accountType);
        } else {
          toast.error("Failed to retrieve token");
        }
      } else {
        const errorMessage = result.data?.detail || "An error occurred";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ... existing code ...

  function handleNavigate(accountType) {
    if (accountType === 0) {
      navigate("/advertiser-account");
    } else if (accountType === 1) {
      navigate("/designeraccount");
    } else if (accountType === 2) {
      navigate("/vehicleowneraccount");
    } else if (accountType === 3) {
      navigate("/installeraccount");
    } else if (accountType === 4) {
      navigate("/photographeraccount");
    }
  }

  return (
    <div>
      <div className="main_2 d-flex justify-content-center align-items-center py-5">
        <div className="signin-box p-2 rounded-3 col-md-7">
          <div onClick={() => navigate(-1)}>
            <IoCaretBack size={35} color={colors.primary} />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="login-form col-md-10 mx-auto">
              <div className="login-head d-flex flex-column align-items-center justify-content-center">
                <Link to={"/"}>
                  <div className="logo" style={{ width: "10rem" }}>
                    <img
                      width={"100%"}
                      src={require("../assets/img/MOOH Logo.png")}
                      alt=""
                      className="mw-100"
                    />
                  </div>
                </Link>
                <ul
                  className="nav nav-pills mb-3 w-75 rounded-pill fs-2 text-white"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item w-50" role="presentation">
                    <button
                      className="nav-link active text-white w-100 rounded-pill p-3"
                      id="pills-sigin-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-signin"
                      type="button"
                      role="tab"
                      aria-controls="pills-signin"
                      aria-selected="true"
                    >
                      Sign In
                    </button>
                  </li>
                  <li className="nav-item w-50" role="presentation">
                    <button
                      className="nav-link text-white w-100 rounded-pill p-3"
                      id="pills-signup-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-signup"
                      type="button"
                      role="tab"
                      aria-controls="pills-signup"
                      aria-selected="false"
                      onClick={() => navigate("/signUpPopup")}
                    >
                      Sign Up
                    </button>
                  </li>
                </ul>
              </div>
              <input
                required
                type="email"
                value={loginData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                placeholder="Email"
                className="form-control input shadow-none bg-transparent rounded-0 py-2 px-0 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
              />
              <div className="position-relative">
                <input
                  required
                  value={loginData.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                  className="form-control input shadow-none bg-transparent rounded-0 py-2 ps-0 pe-4 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
                  type={showPassword ? "password" : "text"}
                  id="password"
                  placeholder="Password"
                />
                <button
                  type="button"
                  className="show-password bg-transparent border-0 position-absolute end-0 top-0 lh-lg fs-5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-fill" />
                  ) : (
                    <i className="bi bi-eye-slash-fill" />
                  )}
                </button>
              </div>
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    id="remember"
                    className="form-check-input p-2"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <label htmlFor="remember" className="fs-5 px-2 lh-base">
                    Remember me
                  </label>
                </div>
                <Link to={"/forgot-password"} className="blue-clr fs-5">
                  Forgot Password?
                </Link>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="login-btn bg-blue rounded-pill text-white fs-3 border-0 px-5 lh-lg"
                >
                  {loading ? "Login..." : "Login"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
